import { computed, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { loop } from '@/utils/loop';
import { ls } from '@sfe/bone-cache';
import { leverageApi } from '@/apis/spot';
import { useSymbol } from '@/hooks/exchange';

export function useOutstandingSub() {
    const active = ls.get('SPOT_outstanding_sub_active');
    if (!active || (active !== 'coin' && active !== 'order')) {
        return 'coin';
    }
    return active;
}

/**
 * 账户余额信息
 */
export function useLeverageBalance() {
    let unSubBalance = null;
    const store = useStore();
    const symbol = useSymbol();
    const isTurnOnLeverage = computed(() => store.state.leverage.isTurnOn);
    const userstate = computed(() => store.state.user.userstate);
    const isUTA = computed(() => store.getters['user/isUTA']);

    const clearSubBalance = () => {
        if (unSubBalance) {
            unSubBalance();
            unSubBalance = null;
        }
    };

    watch([
        () => isTurnOnLeverage.value,
        () => symbol.value.symbolId,
        () => userstate.value,
        () => isUTA.value], ([isTurnOn, symbolId, userStatus, isUnified]) => {
        if (userStatus !== 1) return;

        clearSubBalance();
        if (isTurnOn && symbolId && !isUnified) {
            unSubBalance = loop(async () => {
                if (document.hidden) return; // 非激活页面,不执行请求
                const { baseTokenId, quoteTokenId } = symbol.value;
                const res = await leverageApi.getTotalAvailable({ base_token_id: baseTokenId, quote_token_id: quoteTokenId });
                if (res.success && res.result) {
                    store.commit('balance/SET_ACCOUNT_INFO', res.result);
                }
            }, {
                interval: 3e3,
                immediate: true,
            });
        }
    }, { immediate: true });

    onBeforeUnmount(clearSubBalance);
}
